import React from 'react';
import { TravelOffer, SubscribeCard, Layout } from '../../components';
// import Search from './Search/Search';
import Banner from './Banner/Banner';
import Explore from './Explore/Explore';
import BookBanner from './BookBanner/BookBanner';
import TrendingTrips from "./TrendingTrips";
import MeetCustomers from "./MeetCustomers";

const makkahData = [
  {
    img: './assets/images/Group 2484.png',
    title: 'Masjid al-Haram',
    description: '4.210 facilities',
  },
  { img: './assets/images/Group 2489.png', title: 'Kaaba', description: '610 facilities' },
  { img: './assets/images/Group 2494.png', title: 'Hacel-ül Esved', description: '989 facilities' },
  { img: './assets/images/Group 2499.png', title: 'Mount Arafat', description: '432 facilities' },
  { img: './assets/images/Group 2504.png', title: 'Jabal Al-Nour', description: '232 facilities' },
];

const medinahData = [
  {
    img: './assets/images/img10.png',
    title: 'Masjid-i Nebevi',
    description: '4.210 facilities',
  },
  { img: './assets/images/Group 2280.png', title: 'Mount Uhud', description: '610 facilities' },
  { img: './assets/images/Group 2285.png', title: 'Kuba Mescidi', description: '989 facilities' },
  { img: './assets/images/Group 2290.png', title: 'Jannatul Baqi', description: '432 facilities' },
  { img: './assets/images/Group 2295.png', title: 'Dar Al Madinah', description: '232 facilities' },
];
const Home = () => {
  return (
    <Layout sticky>
      <Banner />
      {/*<Search />*/}
        <Explore
            data={makkahData}
            title={'Explore Makkah'}
            description={'These populer destinations have a lot to offer'}
        />
      <TravelOffer />
      <BookBanner />
      <TrendingTrips/>
      <Explore data={medinahData} title={'Explore Madinah'} description={'Browse by propert type'} />
      <SubscribeCard />
      <MeetCustomers/>
    </Layout>
  );
};

export default Home;
